import { useContext, useEffect } from "react"
import { Field } from "formik"
import { Password } from "primereact/password"
import _ from "lodash"

import { FormContext } from "../../context/formContext"
import styles from "../../styles/Form.module.css"
import fieldVisibility from "../../helpers/fieldVisibility"

export default function TypePassword({ field, block, index }) {
  const form = useContext(FormContext)

  // Determine if the field is disabled
  const isDisabled = field.read_only || (form?.blocksSaved[block] ?? false)

  // Check if the current URL matches any allowed path
  const allowedPaths = ["/form/account_preferences"]
  const currentPath = window.location.pathname
  const isVisible = allowedPaths.some((path) => currentPath.startsWith(path))

  // Check if the field is required (only if it is visible)
  const isRequired = isVisible && _.get(field, "field_validation.required[0]", false)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Hide the component if not visible or in edit mode with specific conditions
  if (!isVisible || (form?.editMode && field.name === "staff_account_password")) {
    return null
  }

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => (
            <>
              <Password
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={isDisabled}
                onBlur={formikField.onBlur}
                toggleMask
                autoComplete="off"
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
